import {Speed} from '../../../Domain/Speed';
import {format} from 'date-fns';

export function formatSplit(speed: Speed | null): {formatted: string; unit?: string} {
    if (speed === null) {
        return {
            formatted: '-',
        };
    }
    const durationPer500Meters = speed.durationPer500Meters;
    if (durationPer500Meters === null) {
        return {
            formatted: '-',
        };
    }

    const millisecondsNotRounded = durationPer500Meters.milliseconds;
    const hundreds = Math.ceil(millisecondsNotRounded / 10);
    const millisecondsRounded = hundreds * 10;

    const date = new Date(millisecondsRounded + new Date().getTimezoneOffset() * 60 * 1000);
    return {formatted: format(date, 'm:ss'), unit: '/500m'};
}

export function formatAverageSplit(speed: Speed | null): {formatted: string; unit?: string} {
    if (speed === null) {
        return {
            formatted: '-',
        };
    }
    const durationPer500Meters = speed.durationPer500Meters;
    if (durationPer500Meters === null) {
        return {
            formatted: '-',
        };
    }

    const millisecondsNotRounded = durationPer500Meters.milliseconds;
    const hundreds = Math.ceil(millisecondsNotRounded / 10);
    const millisecondsRounded = hundreds * 10;

    const date = new Date(millisecondsRounded + new Date().getTimezoneOffset() * 60 * 1000);
    return {formatted: format(date, 'm:ss.SS'), unit: '/500m'};
}
